import React from 'react';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object,
        homeCourse: React.PropTypes.bool,
        id: React.PropTypes.number,
        courseNumber: React.PropTypes.number,
        name: React.PropTypes.string,
        lastPlayed: React.PropTypes.string,
        onRemove: React.PropTypes.func,
        leadingCoursesUrl: React.PropTypes.string,
        courseDetailsUrl: React.PropTypes.string
    },
    getInitialState() {
        return {
            showDetails: false
        }
    },
    toggleDetails() {
        this.setState({
            showDetails: !this.state.showDetails
        })
    },
    renderRemoveButton() {
        const isLoadingClass = (this.state.loading) ? 'is-loading no-spacing' : '';

        return (
            <div className="c-linkBlock__item">
                <button className={`c-button c-button--transparent c-courses__course__remove ${isLoadingClass}`} onClick={this.handleRemoveCourse} disabled={(this.state.loading) ? 'disabled': ''}>
                    <span>
                        <svg className="c-icon c-icon--remove">
                            <use xlinkHref="#remove" />
                        </svg>
                    </span>
                </button>
            </div>
        );
    },
    handleRemoveCourse(e) {
        e.preventDefault();

        if (confirm(`Weet je zeker dat je ${this.props.name} wilt verwijderen?`)) {
            this.setState({
                loading: true
            });

            $.get(this.props.urls.remove, {
                courseId: this.props.id
            }, (result) => {
                if (!result.Error) {
                    this.setState({
                        loading: false
                    });
                    this.props.onRemove(this.props.id);
                } else {
                    alert(this.props.i18n.error);
                    this.setState({
                        loading: false
                    });
                }
            }).fail(() => {
                alert(this.props.i18n.error);
                this.setState({
                    loading: false
                });
            });
        } else {
            this.setState({
                loading: false
            });
        }
    },
    render() {
        const showDetailsClass = (this.state.showDetails) ? 'c-linkBlock__follow--active' : '';

        let url = this.props.courseDetailsUrl.replace('{courseId}', this.props.id);
        url = url.replace('{courseNumber}', this.props.courseNumber);

        return (
            <a href={url} className="c-module">
                <div className="c-linkBlock">
                    <div className="c-linkBlock__wrapper">
                        <div className="c-linkBlock__item">
                            <div className={`c-linkBlock__follow ${showDetailsClass}`}>
                                <svg className="c-icon c-icon--arrow">
                                    <use xlinkHref="#arrow2" />
                                </svg>
                            </div>
                        </div>
                        <div className="c-linkBlock__headers">
                            <div className="c-linkBlock__title">{this.props.name}</div>
                            <div className="c-linkBlock__subtitle">{this.props.lastPlayed}</div>
                        </div>
                        {!this.props.homeCourse && this.renderRemoveButton()}
                    </div>
                </div>
            </a>
        );
    }
});
